/**
 * Maneja la búsqueda y filtra un array de elementos según el término ingresado.
 *
 * @param {Event} event - Evento del input (onChange).
 * @param {Array} items - Array original de elementos a filtrar.
 * @param {Function} setSearchTerm - Función para actualizar el estado del término de búsqueda.
 * @param {Function} setFilteredItems - Función para actualizar el estado del array filtrado.
 */
export const handleSearch = (event, items, setSearchTerm, setFilteredItems) => {
    const term = event.target.value.toLowerCase();
    setSearchTerm(term);
  
    if (term === "") {
      setFilteredItems(items);
    } else {
      setFilteredItems(
        items.filter((item) =>
          item.nombre.toLowerCase().includes(term)
        )
      );
    }
  };
  